<div>
  <label *ngIf="label" [for]="id" [class.readonly]="readonly"
    >{{ label }}
    <app-dc-popover
      *ngIf="helpText"
      [body]="helpText"
      [class.helpText]="helpText"
    ></app-dc-popover
  ></label>
  <div [class]="'input-group' + ' ' + (darkMode === true ? 'dark' : '')">
    <ng-container [formGroup]="displayForm">
      <p-calendar
        formControlName="displayDate"
        appendTo="body"
        [baseZIndex]="10000"
        (onFocus)="onFocus()"
        [showOtherMonths]="false"
        dateFormat="dd/mm/yy"
        [showTime]="showTime"
        [showIcon]="true"
      >
      </p-calendar>
    </ng-container>
    <input [formControl]="control" type="hidden" />

    <app-dc-control-validation
      *ngIf="control.touched"
      [status]="getValidationStatus()"
      class="{{
        control.hasError('required') && control.touched ? 'required' : ''
      }}"
      body="{{ customErrorMessage ? customErrorMessage + '.' + '<br/>' : '' }}{{
        control.hasError('required') ? 'Required field' + '.' + '<br/>' : ''
      }}{{ control.hasError('incorrect') ? control.errors.message + '.' : '' }}"
    ></app-dc-control-validation>
  </div>
</div>
